@if (variant() === 'empty') {
  <div class="pending pending--empty">
    <span class="pending__badge"><i class="pi pi-inbox" aria-hidden="true"></i></span>
    <strong class="pending__title">{{ headline() }}</strong>
    <p class="pending__text">
      Estão na pasta de contrato social da empresa. Ao processar, o Cog classifica os que ainda não
      têm tipo e lê o contrato social, as alterações, o estatuto e as atas. O societário vigente
      aparece aqui quando a leitura terminar.
    </p>
    @if (breakdown()) {
      <span class="pending__breakdown">{{ breakdown() }}</span>
    }
    <ng-container *ngTemplateOutlet="docList" />
    <div class="pending__actions">
      @if (canEdit()) {
        <app-button
          [icon]="'pi pi-bolt'"
          [label]="'Processar documentos do Data Room'"
          theme="darkblue"
          [noMargin]="true"
          [isLoading]="processing()"
          [loadingText]="'Enviando...'"
          (sendButtonClick)="process.emit()" />
      }
      <app-button
        [icon]="'pi pi-folder-open'"
        [label]="'Abrir Data Room'"
        theme="outline-grey"
        [noMargin]="true"
        (sendButtonClick)="openDataRoom.emit()" />
    </div>
    @if (!canEdit()) {
      <p class="pending__hint">
        Quem pode editar o Data Room da empresa consegue enviar estes documentos para o Cog.
      </p>
    }
  </div>
} @else {
  <div class="pending pending--compact" role="status">
    <div class="pending__row">
      <i class="pi pi-inbox pending__icon" aria-hidden="true"></i>
      <span class="pending__message">{{ headline() }}</span>
      <button
        type="button"
        class="pending__toggle"
        [attr.aria-expanded]="expanded()"
        (click)="toggle()">
        {{ expanded() ? 'Ocultar' : pending().total === 1 ? 'Ver qual' : 'Ver quais' }}
        <i
          class="pi"
          [class.pi-chevron-down]="!expanded()"
          [class.pi-chevron-up]="expanded()"
          aria-hidden="true"></i>
      </button>
      <span class="pending__spacer"></span>
      @if (sent()) {
        <span class="pending__sent">
          <i class="pi pi-check" aria-hidden="true"></i>Enviado ao Cog. A tela se atualiza sozinha.
        </span>
      } @else if (canEdit()) {
        <app-button
          [icon]="'pi pi-bolt'"
          [label]="'Processar documentos do Data Room'"
          theme="outline-grey"
          size="small"
          [noMargin]="true"
          [isLoading]="processing()"
          [loadingText]="'Enviando...'"
          (sendButtonClick)="process.emit()" />
      }
    </div>
    @if (expanded()) {
      <ng-container *ngTemplateOutlet="docList" />
    }
  </div>
}

<ng-template #docList>
  <ul class="docs">
    @for (doc of visibleDocuments(); track doc.documentId) {
      <li class="docs__item">
        <i class="pi pi-file docs__icon" aria-hidden="true"></i>
        <button
          type="button"
          class="docs__name"
          [title]="'Abrir no Data Room: ' + doc.folderPath + ' / ' + doc.name"
          [disabled]="openingDocumentId() === doc.documentId"
          (click)="openDocument.emit(doc.documentId)">
          {{ doc.name }}
        </button>
        <span class="docs__path" [title]="doc.folderPath">{{ doc.folderPath }}</span>
      </li>
    }
    @if (hiddenCount() > 0) {
      <li class="docs__more">
        e mais {{ hiddenCount() }} {{ hiddenCount() === 1 ? 'documento' : 'documentos' }}
      </li>
    }
  </ul>
</ng-template>
